module.exports = __webpack_public_path__ + "static/media/file.3f261691.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/icons/file.svg
// module id = 1609
// module chunks = 0